import React from 'react';
import { motion } from 'framer-motion';
import VisualCanvas from './VisualCanvas';

const MissionSection = () => {
    return (
        <section className="py-24 md:py-32 min-h-[auto] md:min-h-screen flex items-center bg-white border-y border-slate-100 transition-colors duration-500 perspective-container relative overflow-hidden">
            {/* Background 3D */}
            <div className="absolute inset-x-0 top-0 bottom-0 opacity-[0.05] pointer-events-none">
                <VisualCanvas type="sphere" color="#2563eb" height="100%" />
            </div>

            <div className="container mx-auto px-4 md:px-6 text-center relative z-10">
                <motion.span
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="bg-slate-50 border border-slate-100 text-primary px-5 py-2 md:px-8 md:py-2.5 rounded-full font-black uppercase tracking-[0.4em] text-[10px] md:text-xs mb-8 md:mb-12 inline-block shadow-sm"
                >
                    Our Philosophy
                </motion.span>
                <motion.blockquote
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="text-2xl md:text-3xl lg:text-5xl font-black text-slate-900 max-w-5xl mx-auto leading-[1.2] italic tracking-tight"
                >
                    "We engineer scalable, secure, and <br className="hidden md:block" /> <span className="text-gradient">high-performance digital solutions</span> <br className="hidden md:block" /> that accelerate business evolution in a connected world."
                </motion.blockquote>
            </div>
        </section>
    );
};

export default MissionSection;
